<template>
  <div class="container">
    <div style="width: 1260px; margin: 0 auto; display: flex; height: 100%">
      <div class="tab">
        <div class="tab_title"><common-data name="appShortName_11"/></div>
        <!-- <div class="underline"></div> -->
        <ul>
          <li
            v-for="(item, index) in contentList"
            :key="index"
            class="tit-left-item"
            :class="{ active: index == id }"
            @click="selectContent(item.id)"
          >
            <span>{{ item.name }}</span
            >
          </li>
        </ul>
      </div>
      <div class="content">
        <div class="con-text">
          
          <div class="text-txt">
            <div class="wrap" >
                
                  <div v-if="id == 0">
                    
                    <p class="paragraph" >
                      模组是<common-data name="appShortName_11"/>的运行管理平台，列表式的管理界面，对各个模型的运行集中管理，每一个运行单元的总收益，当前的信号、下单、持仓、持仓盈亏等数据一目了然。
                    </p>
                    <p class="paragraph" >
                      模组还支持收益分析、资金管理、持仓匹配校验、手动加减仓干预等功能。
                    </p>
                    <BaseBigimg
                      :src="require('./imageswh8/T8-mz1.jpg')"
                    ></BaseBigimg>
                  
                  </div>
                  <div v-if="id == 1">
                    
                    <p class="paragraph" style="padding-bottom: 5px">
                      远程监控是交易员的操作页面，支持在交易员接触不到模型的情况下，监控模型运行，保证模型的下单指令得到有效执行。交易员虽然不直接参与下单，但当出现网络不稳定、行情剧烈波动等情况，导致信号委托无法成交时，需要交易员进行撤单、追价等操作，保证每一个信号能够完整、连续的执行。
                    </p>
                    <p class="paragraph" style="padding-top: 0">
                      <common-data name="appShortName_11"/>支持远程监控模组各个单元在云主机上的运行和网络状态，需要时可手动干预，进行撤单和追价操作。
                    </p>
                    <p class="img_center">
                      <img
                        src="./imageswh8/pic_04.png"
                        style="margin-bottom: 30px"
                      />
                    </p>
                   
                  </div>
                  <div v-if="id == 2">
                    
                    <p class="paragraph">
                      头寸管理，即量化模型中的资金使用计划，包括使用的保证金数量、下单手数的规划、风险管理等。如果说模型赚不赚钱是由进出场条件决定的，那么大赚还是小赚则是由头寸管理决定。
                    </p>
                    <p class="paragraph">
                      <common-data name="appShortName_11"/>提供39个头寸管理函数，对于用户设计资金使用比例、下单手数、结合盈亏动态调控仓位、根据权益回撤进行风控等场景都能有效支持，在资金合理利用的前提下让盈利奔跑。
                    </p>
                    <p class="paragraph">
                      含有头寸管理函数的模型装入到模组中运行时，模组可为每个运行单元分配独立的资金，各单元独立计算盈亏、可用资金及权益变化，为机构多策略、多周期、多合约组合运行提供了有力的保障。
                    </p>
                    <BaseBigimg
                      :src="require('./imageswh8/TCGL-2.jpg')"
                    ></BaseBigimg>
                    
                  </div>
                  <div v-if="id == 3">
                    
                    <p class="paragraph" style="padding-bottom: 5px">
                      这个功能用于在电脑、网络以及其他交易环境故障，导致信号没有得到有效执行的情况下，进行手动处理。
                    </p>
                    <p class="paragraph" style="padding: 0">
                      当模组的运行单元数量较多时，逐一去检查单元持仓和理论持仓是否匹配费时费力。<common-data name="appShortName_11"/>提供智能的持仓匹配校验功能，可一键校验运行单元的持仓匹配情况，方便进行手动处理。
                    </p>
                    <BaseBigimg
                      :src="require('./imageswh8/cpys3.jpg')"
                    ></BaseBigimg>
                    <p class="paragraph" style="padding-bottom: 5px">
                      手动处理的方法如下：单元持仓小于理论持仓的情况下，可在模组里点击“加仓”按钮来补仓，完成持仓匹配。模组会把以上加仓操作的成交价格自动带入运行单元，作为收益计算的依据，不会影响模组的继续运行和实际收益的统计。
                    </p>
                    <BaseBigimg
                      :src="require('./imageswh8/cpys3_1.jpg')"
                    ></BaseBigimg>
                    
                  </div>
                  <div v-if="id == 4">
                    

                    <p class="paragraph">
                      在一个运行单元带一个账号的情况下，软件支持申购/赎回管理。模型写头寸管理函数实现按理论资金比例下单，当一只资管产品需要进行申购/赎回时，可在资金管理界面，对该产品的运行单元进行出入金操作，后续的开仓指令，模型会根据调整后的资金重新计算下单手数。
                    </p>
                    <p class="paragraph">
                      投资经理可以根据每个运行单元的实盘运行情况，确定申购/赎回的金额，通过汇总查看此次申购/赎回的总金额。
                    </p>
                    <BaseBigimg
                      :src="require('./imageswh8/T8-mz501.jpg')"
                    ></BaseBigimg>
                    
                  </div>
                  <div v-if="id == 5">
                    
                    <p class="paragraph">
                      模型可以绑定多个账号，每一个账户可以设置手数倍率，模组可以根据每一个账户的量化下单记录，做收益分析以及胜率、盈亏比等统计。
                    </p>
                    <p class="paragraph">
                      多账户可以跨不同期货公司、跨不同交易后台（CTP、金仕达、恒生多种后台）登录，支持最多配置10个交易账户。
                    </p>
                    <BaseBigimg
                      :src="require('./imageswh8/dzh-38.jpg')"
                    ></BaseBigimg>
                    
                  </div>
                  <div v-if="id == 6">
                   
                    <p class="paragraph">
                      主连链回测是一种严谨的利用长期数据验证策略的方法，不再使用品种主连自身的k线数据计算信号，而是采用各个月份合约自挂牌以来的全部k线数据计算信号，规避品种主连k线数据换月跳空、新旧合约趋势相反等情况对量化计算准确性的影响。主力换月时，旧主力月份平仓，新主力根据月份合约的k线数据重新计算开仓信号。
                    </p>
                    <p class="img_center">
                      <img
                        src="./imageswh8/630-tu.jpg"
                        style="margin-bottom: 30px"
                      />
                    </p>
                    
                  </div>
                  <div v-if="id == 7">
                    
                    <p class="paragraph">
                      多模型组合交易能够分散交易风险，组合配置功能分分钟为你出具历史数据回测报告。以tick精准历史回测为基础，进行多品种、多策略、多周期任意组合的测试，助你搭建最优的投资组合。
                    </p>
                    <p class="img_center"><img src="./imageswh8/pic_02.png" /></p>
                   
                  </div>
                  <div v-if="id == 8">
                    
                    <p class="paragraph" style="padding-bottom: 5px">
                      多因子分析是一种构建最优投资组合的方法。量化策略大多基于技术分析的，管理的是买卖点，赚取买卖价差，属于择时交易。<common-data name="appShortName_11"/>的期货多因子分析实现了期货品种横向的对比，可更多从非技术面的角度去筛选能够带来更多超额收益的品种。
                    </p>
                    <p class="paragraph" style="padding-top: 0">
                      精选期货因子囊括量价、动量、期限结构、持仓、基本面、BETA六大类精选因子，以期货市场全品种为标的，提供单因子筛选、多因子排名分析等功能。可借助多因子综合排名信息，筛选出能够带来更多超额收益的品种，构建最优组合。还可以对多个品种在同一时间点的强弱情况进行对比分析，建立对冲组合，实现期货横截面交易策略。
                    </p>
                    <p class="img_center"><img src="./imageswh8/dyz.png" /></p>
                    
                  </div>
              
                  <div v-if="id == 9">
                    
                    <p class="paragraph">
                      股票T+1策略运行池是进行股票趋势量化投资的工具，可通过编写股票T+1策略模型构建一篮子股票的量化投资策略。借助云计算技术，软件可在短时间内生成一篮子股票投资组合的回测报告，报告囊括了八大类，近百项统计数据，并提供资金曲线、持仓明细、交易列表等多维度、多视角的回测数据助力策略研发。最新交易列表支持导出下单文件，可配合文件下单功能实现股票半自动交易。
                    </p>
                    <p class="img_center">
                      <img
                        style="margin-bottom: 50px"
                        src="./imageswh8/gpt1-1.png"
                      />
                    </p>
                    
                  </div>

                  
                 
               
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="loading" v-if="showloading">
      <img src="../assets/img/loading.gif" alt="" style="position:absolute;top:42%;left:50%;">
    </div> -->
    <!-- <BaseHover :message="message" v-show="!!message" class="basehover" :style="{left:left+'px',top:top+'px'}"></BaseHover>
    <BaseAlert @close="close" v-if="showalert"></BaseAlert> -->
  </div>
</template>
<script>
import axios from "axios";
import Svgg from "../../components/Svgg.vue";
import Basecharts from "../../components/Basecharts.vue";
import BaseHover from "../../components/BaseHover.vue";
import BaseAlert from "../../components/BaseAlert.vue";

export default {
  components: {
    Basecharts,
    BaseHover,
    BaseAlert,
    Svgg,
  
  },
  watch: {
    // "currentComponent": {
    //   handler: function (newd) {
    //     console.log(newd)
    //     console.log(document.documentElement.getElementsByClassName('img_center')[0])
    //   },
    //   deep:true,
    //   immediate:true,
    // },
    "$route.query.id": {
      handler: function (newd) {
        console.log(newd);
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    console.log(this.$route.query.id);
  },
  data() {
    return {
      id: 0,
      contentList: [
        {
          name: "模型运行管理中心",
          id: 0,
        },
        {
          name: "远程监控模型运行情况",
          id: 1,
        },
        {
          name: "头寸管理",
          id: 2,
        },
        {
          name: "模组持仓匹配校验",
          id: 3,
        },
        {
          name: "资管产品的申购/赎回管理",
          id: 4,
        },
        {
          name: "多账户量化",
          id: 5,
        },
        {
          name: "主连链回测",
          id: 6,
        },
        {
          name: "组合配置",
          id: 7,
        },
        {
          name: "期货多因子",
          id: 8,
        },
        {
          name: "股票T+1策略运行池",
          id: 9,
        },
        
      ],
      
    };
  },
  methods: {
    selectContent(id) {
      this.id = id;
    },  
  },
};
</script>
<style scoped src="./index.css"></style>
<style scoped>
.trans {
  transform: rotate(180deg);
}
.container {
  padding-top: 50px;
  height: 100%;
  min-height: 400px;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=82) no-repeat top,
    url(../../assets/img/bgonepp.jpg) repeat-y center top 1134px;
  text-align: left;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 999;
}
.content {
  color: rgb(132, 133, 135);
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: 100%;
  min-height: 600px;
  /* margin-left: 40px; */
  background: #fff;
  box-shadow: -1px 0px 3px 0px rgba(209, 222, 238, 0.9);
  /* padding-top: 23px; */
  font-size: 17px;
}
.tab ul li {
  width: 200px;
}
/* .tab {
  width: 210px;
}
.tab_title {
  font-size: 20px;
  font-weight: 570;
  line-height: 40px;
  padding-left: 8px;
  color: #323232;
  margin-top: 25px;
}
.underline {
  width: 30px;
  height: 2px;
  background: #323232;
  margin-left: 8px;
}
.tab ul {
  margin-top: 20px;
}
.tab ul li {
  color: #808080;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  width: 200px;
  padding-left: 12px;
  background: transparent;
  cursor: pointer;
  margin-bottom: 10px;
  border-radius: 0 50px 50px 0;
  padding-right: 18px;
}
.tab ul li:hover {
  color: #3b78f7;
  
}
.tab ul li.active {
  color: #3b78f7;
  background-image: linear-gradient(90deg, #f9feff, #e9f6ff, #dfebf7);
  background-image: -moz-linear-gradient(90deg, #f9feff, #e9f6ff, #dfebf7);
  box-shadow: #d1d6e5 1px 1px 5px 2px;
  
} */
.text-title {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* width: 1096px; */
  margin: 0 60px;
}
.text-txt {
  padding-top: 5px;
  font-size: 15px;
  min-height: 600px;
  background: #f6f9fe;
  /* margin-top: 3px; */
  padding-bottom: 40px;
  border-radius: 10px 10px 0 0;
}
.tit-left {
  display: flex;
  flex-direction: row;
}
.right-tip {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 1005px;
  margin: 0 auto;
  cursor: pointer;
}
.right-tip div {
  padding: 2px 4px;
}
/* .right-tip div.active{
  color: white;
  background: #4b63f7;
} */
.tit-left-item {
  cursor: pointer;
  /* padding: 6px 18px; */
  position: relative;
  color: #181818;
}
/* .tit-left-item.active{
  color: #4b63f7;
  border-bottom: 3px solid #4b63f7;
} */
.txt-left-item {
  cursor: pointer;
  margin: 0 18px;
  padding: 3px 0px;
  font-size: 16px;
}
.txt-left-item:hover {
  color: #536b99;
}
.txt-left-item.active {
  color: #5268cd;
  border-bottom: 3px solid #5268cd;
  font-weight: bold;
}
.txt-img {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 1029px;
  margin: 0 auto;
  margin-top: 5px;
}
.base-ech {
  margin: 0px 12px;
  margin-bottom: 26px;
}
.txt-title {
  display: flex;
  flex-direction: row;
  /* margin-left: 50px; */
}
.txt-table {
  margin-top: 5px;
}

</style>